<template>
	<v-container class="mt-4 ml-2" fluid>
	  <v-row>
	  	<v-col cols="12">
	  		<v-card class="shadowCard">
	  		  <v-card-title primary-title>
	  		    <span class="text-subtitle-1">Colegiaturas</span>
	  		    <v-spacer></v-spacer>
            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon small>mdi-refresh</v-icon>
            </v-btn>
	  		  </v-card-title>
          
	  		  <v-card-text>
	  		  	<v-row justify="space-between">
	  		  		<v-col cols="12" lg="3" md="6">
	  		  			<v-autocomplete
				          filled
				          dense
				          clearable
				          v-model="plantel"
				          :items="planteles"
				          label="Plantel"
				          hide-details
				          item-text="plantel"
				          item-value="id_plantel"
				          clearable
				        >
	        			</v-autocomplete>
	  		  		</v-col>

	  		  		<v-col cols="12" lg="6" md="6">
	  		  			<v-text-field
	  		  			  name="name"
	  		  			  label="Buscar"
	  		  			  id="id"
	  		  			  filled
	  		  			  dense
	  		  			  hide-details
	  		  			  append-icon="mdi-magnify"
	  		  			  v-model="search"
	  		  			></v-text-field>
	  		  		</v-col>

	  		  	</v-row>

	  		    <v-row>
	  		    	<v-col cols="12">

	  		    		<v-data-table
							    :headers="headerColegiaturas"
							    :items="colegiaturas"
							    class="elevation-0"
							    :search="search"
							    :mobile-breakpoint="100"
			            dense
							  >
							    <template v-slot:item.actions="{ item }">
							    	<v-btn
							    		color="grey"
							    		x-small
			                @click="editItem(item)"
							    		icon
							    	>
							    		<v-icon>mdi-pencil</v-icon>
							    	</v-btn>
                  </template>

							  </v-data-table>

	  		    	</v-col>
	  		    </v-row>
	  		  </v-card-text>
	  		</v-card>
	  	</v-col>
	  </v-row>

	  <!-- Dialogo de editar o agregar-->
	  <v-dialog
      v-model="dialog"
      max-width="1000px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">Pagos del alumno</span>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text>
          <v-row>

          	<v-col cols="12" v-if="infoSistema">
          		<v-list class="transparent">
					      <v-list-item>
					        <v-list-item-title>Fecha</v-list-item-title>
					        <v-list-item-subtitle class="text-right black--text">
					          <b>{{ infoSistema.fecha_creacion }}</b>
					        </v-list-item-subtitle>
					      </v-list-item>
					      <v-divider></v-divider>

					      <v-list-item>
					        <v-list-item-title>Frecuencia</v-list-item-title>
					        <v-list-item-subtitle class="text-right black--text">
					        	<v-spacer></v-spacer>
					          <v-radio-group
								      v-model="infoSistema.frecuencia_pago"
								      row
								      small
								      readonly
								    >
								      <v-radio
								        :label="`Mensual`"
								        :value="1"
								      ></v-radio>
								      <v-radio
								        :label="`Semanal`"
								        :value="2"
								      ></v-radio>
								    </v-radio-group>
					        </v-list-item-subtitle>
					      </v-list-item>
					      <v-divider></v-divider>

					      <v-list-item>
					        <v-list-item-title>Pago reccurente</v-list-item-title>
					        <v-list-item-subtitle class="text-right black--text">
					          <b>{{ infoSistema.pago_recurrente }}</b>
					        </v-list-item-subtitle>
					      </v-list-item>
					      <v-divider></v-divider>

					      <v-list-item>
					        <v-list-item-title>Total de pagos</v-list-item-title>
					        <v-list-item-subtitle class="text-right black--text" v-if="infoSistema.pagados">
					          <b>{{ infoSistema.pagados.length }}</b>
					        </v-list-item-subtitle>
					      </v-list-item>
					      <v-divider></v-divider>

					    </v-list>
          	</v-col>

          	<v-col cols="12">
          		Calendario de pagos
          		<v-row>
          			<v-col cols="12" md="4" lg="2" v-for="(cal, i) in calendario" :key="i">
          				<v-chip dark label :color="cal.color">Semana/Mes: {{cal.semana}}</v-chip>
          			</v-col>
          		</v-row>
          	</v-col>

          	<v-col cols="12" v-if="infoSistema">
          		Pagos realizados

          		<v-data-table
						    :headers="headersGrupos"
						    :items="infoSistema.pagados"
						    class="elevation-0"
						    :mobile-breakpoint="100"
		            dense
						  >
						    <template v-slot:item.forma_pago="{ item }">
						    	<v-btn
						    		outlined
						    		color="green"
						    		x-small
						    		v-if="item.forma_pago == 1"
						    	>Efectivo</v-btn>

						    	<v-btn
						    		outlined
						    		color="orange"
						    		x-small
						    		v-if="item.forma_pago == 2"
						    	>Deposito</v-btn>

						    	<v-btn
						    		outlined
						    		color="red"
						    		x-small
						    		v-if="item.forma_pago == 3"
						    	>Tarjeta</v-btn>
                </template>

                <template v-slot:item.pagado="{ item }">
						    	{{ format( item.pagado ) }}
                </template>

						  </v-data-table>
          	</v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            @click="close"
            dark
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
      	<v-card-text>
	      	<v-row justify="space-around">
	      		<v-col cols="6">
	      			<v-card class="elevation-0" height="100%" style="display: table;">
		      			<div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
		      				<strong>Eliminar</strong> ¿Estás seguro que deseas eliminar el grupo?
			      			<v-card-actions class="pt-6">
			      				<!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
			      			  <v-btn color="error" text  class="mr-2" @click="closeDelete()">No, cancelar</v-btn>
			      			  <!-- Guardar la información  -->
			      			  <v-btn color="#5C5C5C"  dark class="elevation-6"  @click="deleteItemConfirm()">Si</v-btn>
			      			</v-card-actions>
		      			</div>
	      			</v-card>
	      		</v-col>
	      		<v-col cols="5">
	      			<v-img src="@/assets/borrar.png"></v-img>
	      		</v-col>
		      </v-row>
      	</v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>
<script>

	import axios from 'axios';
	import { mapGetters } from 'vuex'
	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'


  export default {

    mixins: [ validarErrores, funcionesExcel ],

  	components:{
      Alerta,
      carga,
    },

    data: () => ({
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      tipoPago: 1,

      fecha: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

      opPago: null,
      paquete: null,
			paquetes: [],
			cantidad:1,
			comprarPaquetes : [],
			comprarArticulos: [],

      url: '',
      tipo_pago: null,
			tipos_pago:[
      	{ id: 1, tipo: 'EFECTIVO'},
      	{ id: 2, tipo: 'DEPOSITO / TRANSFERENCIA'},
      	{ id: 4, tipo: 'TARJETA' },
      ],

      dragging: false,
      vistaPrevia: [],
      archivos:null,

      file: null,


      dialog: false,
      dialogDelete: false,
      
      editedIndex: -1,

      editedItem: {
        idgrupos:0,
				idplanteles:null,
				idhorarios:null,
				idcursos:null,
				cupo:null,
				idmaestros:null,
				fechainicio:null,
				fechafinal:null,
				deleted:0,
				fecha_creacion:null,
      },

      defaultItem: {
        idgrupos:0,
				idplanteles:null,
				idhorarios:null,
				idcursos:null,
				cupo:null,
				idmaestros:null,
				fechainicio:null,
				fechafinal:null,
				deleted:0,
				fecha_creacion:null,
      },

      // Filtros: 
      incio:null,
			fin:null,

      // tabla
			search:'',

      headerColegiaturas:[
      	{ text: 'Alumno'        , value: 'alumno'        },
      	{ text: 'Correo'        , value: 'correo'        },
      	{ text: 'Curso'         , value: 'curso'         },
      	{ text: 'Horario'       , value: 'horario'       },
        { text: 'Plantel'       , value: 'plantel'       },
        { text: 'Fecha Alta'    , value: 'fecha_creacion' },
        { text: 'Actions'       , value: 'actions', sortable: false },
      ],

      headersGrupos:[
      	{ text: 'Alumno'        , value: 'alumno'        },
      	{ text: 'Curso'         , value: 'curso'         },
      	{ text: 'Horario'       , value: 'horario'       },
        { text: 'Tipo de pago'  , value: 'forma_pago'    },
        { text: 'Plantel'       , value: 'plantel'       },
        { text: 'Pagado'        , value: 'pagado'        },
        { text: 'Fecha Alta'    , value: 'fecha_creacion' },
        { text: 'Actions'       , value: 'actions', sortable: false },
      ],


      cursos:[],
      horarios:[],
      planteles:[],
      alumnos:[],
      inscritos:[],
      teachers:[],
      dialogAlumnos:false,
      alumno: null,

      deleteAlumno: {
        idgruposalumnos:0,
        deleted: 0
      },

      dialogDeleteAlumno: false,
      pagado: 0,

      forma_pago: null,
      articulo: null,
			articulos:[],
			pagosPaquetesList:[],
			pagosArticulosList:[],
			grupoAnterior: null,
			grupos:[],
			grupo: null,
			frecuencia_pago: null,
			pago_inscripcion: 0,
			total_pagado_grupo:0,
			pagosGruposList:[],

			plantel: null,
			colegiaturas:[],
			infoSistema: null,
			calendario: []
			
    }),

    computed: {
    	...mapGetters('login',['getdatosUsuario']),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar grupo' : 'Editar grupo'
      },

    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

      dialogAlumnos ( val ){
      	val || this.closeAlumnos( )
      },

    },

    async created () {
      this.url = this.$http.options.root + 'articulos-enlace/';
      await this.initialize()
    },

    methods: {
      async initialize() {
			  await Promise.all([
			    this.getColegiaturas()
			  ])
			},

      async getColegiaturas() {
			  this.cargar = true
			  this.colegiaturas = []

			  try {
			    const response = await this.$http.post('compras.colegiaturas')
			    this.colegiaturas = response.data.filter( el => el.idalumnos == this.getdatosUsuario.idalumnos )

			    console.log( this.colegiaturas )
			  } catch (error) {
			    this.validarError(error)
			  } finally {
			    this.cargar = false
			  }
			},

      async editItem (item) {

        this.cargar = true
			  this.infoSistema = []

			  try {

			    const response = await this.$http.post('colegiatura.alumno', item )

			    this.calendario  = response.data.calendario
			    this.infoSistema = response.data
	        this.editedIndex = this.colegiaturas.indexOf(item)
	        this.editedItem = Object.assign({}, item)
	        this.dialog = true

			    console.log( this.infoSistema )

			  } catch (error) {

			    this.validarError(error)

			  } finally {

			    this.cargar = false

			  }

      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeAlumnos () {
        this.dialogAlumnos = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save ( ) {

      	// Lo mandapos por el EP
        this.$http.post('update.grupoalumnos', this.infoSistema ).then(response=>{

					this.close( )
        	this.initialize( )
        	this.cargar = false
        }).catch( error =>{
        	this.validarError( error )
      	}).finally( () => { this.cargar = false })

      },

	    format( valor ){
	      return valor.toLocaleString('es-MX', {
	        style: 'currency',
	        currency: 'MXN'
	      });
	    },

	    async download( item ){

	    	this.cargar = true

			  try {

			    const response = await this.$http.post('colegiatura.alumno.pdf', item )

	    		this.cargar = false

			    console.log( response.data )

			  } catch (error) {

			    this.validarError(error)

			  } finally {

			    this.cargar = false

			  }

	    }
    },
  }
</script>


<style scoped>
  .dropZone {
    width: 80%;
    height: 150px;
    position: relative;
    border: 2px dashed #eee;
  }

  .dropZone:hover {
    border: 2px solid #D8D8D8;
  }

  .dropZone:hover .dropZone-title {
    color: #1975A0;
  }

  .dropZone-info {
    color: #A8A8A8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  ..dropZone-title {
    color: #787878;
  }

  .dropZone input {
    position: absolute;
    cursor: pointer;
    top: 0px;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  .dropZone-upload-limit-info {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
  }

  .dropZone-over {
    background: #D8D8D8;
    opacity: 0.8;
  }

  .dropZone-uploaded {
    width: 80%;
    height: 200px;
    position: relative;
    border: 2px dashed #eee;
  }

  .dropZone-uploaded-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #D8D8D8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  .removeFile {
    width: 200px;
  }
</style>